<template>
    <div class="popup-content-inner">
        <ComposeInternal
            v-show="tab === 'internal'"
            @refer-md="forwardReferMD"
            @get-md-name="forwardGetMDName"
            @refer-employee="forwardReferEmployee"
            @get-employee-name="forwardGetEmployeeName"
        />

        <ComposeExternal
            v-show="tab === 'external'"
            @refer-md="forwardReferMD"
            @get-md-name="forwardGetMDName"
            @refer-client="forwardReferClient"
            @get-client-name="forwardGetClientName"
            @refer-branch="forwardReferBranch"
            @get-branch-name="forwardGetBranchName"
            @refer-user="forwardReferUser"
            @get-user-name="forwardGetUserName"
        />

        <ComposeGroup v-show="tab === 'group'" :list-span-member="listSpanMember" @set-list-span-member="$emit('set-list-span-member')" />

        <div class="field-item d-flex align-items-end justify-content-end gap-2 p-2">
            <ans-button label="キャンセル" class="btn-cancel" style="background: #6c757d !important; color: white" @click="$emit('clear-form')" />
            <ans-button label="送信" class="btn-send" @click="$emit('submit-form')" :is-disabled="!canSubmit" />
        </div>
    </div>
</template>

<script>
import ComposeInternal from './ComposeInternal.vue';
import ComposeExternal from './ComposeExternal.vue';
import ComposeGroup from './ComposeGroup.vue';
import { mapState } from 'vuex';

export default {
    name: 'MessageComposeSection',
    components: { ComposeInternal, ComposeExternal, ComposeGroup },
    props: {
        tab: { type: String, default: '' },
        listSpanMember: { type: Array, default: () => [] }
    },
    computed: {
        ...mapState('app', ['user', 'isShowLeftMenu', 'dmMessageMode']),
        ...mapState('MNG_DM_Message_Store', ['data', 'options']),
        canSubmit() {
            const requiredMap = {
                internal: ['MDCD', 'EmployeeCD', 'Subject', 'Body'],
                external: ['MDCD', 'ClientCD', 'BranchCD', 'UserID', 'Subject', 'Body'],
                group: ['GroupID', 'Subject', 'Body']
            };
            const isFilled = (v) => String(v || '').trim();
            const fields = requiredMap[this.tab] || [];
            const data = this.data[this.tab] || {};

            return fields.every((f) => isFilled(data[f]));
        }
    },
    methods: {
        forwardReferMD(index, value, item) {
            this.$emit('refer-md', index, value, item);
        },
        forwardGetMDName(value, item) {
            this.$emit('get-md-name', value, item);
        },
        forwardReferEmployee(index, value, item) {
            this.$emit('refer-employee', index, value, item);
        },
        forwardGetEmployeeName(value, item) {
            this.$emit('get-employee-name', value, item);
        },
        forwardReferClient(index, value, item) {
            this.$emit('refer-client', index, value, item);
        },
        forwardGetClientName(value, item) {
            this.$emit('get-client-name', value, item);
        },
        forwardReferBranch(index, value, item) {
            this.$emit('refer-branch', index, value, item);
        },
        forwardGetBranchName(value, item) {
            this.$emit('get-branch-name', value, item);
        },
        forwardReferUser(index, value, item) {
            this.$emit('refer-user', index, value, item);
        },
        forwardGetUserName(value, item) {
            this.$emit('get-user-name', value, item);
        }
    }
};
</script>

<style scoped>
.btn-cancel {
    width: 113px !important;
    font-weight: bold;
    background: #6c757d !important;
    color: white;
}
.btn-send {
    width: 80px !important;
    font-weight: bold;
}
</style>
